import React, { PropTypes } from 'react';
import classnames from 'classnames';
import Pricing from 'landing_pages/containers/pricing';
import { reduxForm, Field } from 'redux-form';
import PricingCategory from 'marketing/containers/pricing_category';

const Form = ({ subcategory_id }) => (
  <form>
    <Field component={Pricing} name="pricing" category={subcategory_id} />
  </form>
);

const WrappedForm = reduxForm({ form: 'PRICING_MODULE_FORM' })(Form);

const PricingModule = ({ subcategory_id, title, subtitle, cta_html, background }) => (
  <section className={classnames("block block-pricing", background)}>
    <div className="row columns">
      <div className="block-header">
        <h2>{title}</h2>
        { !!subtitle && <h3 className="subtitle">{ subtitle }</h3> }
      </div>
    </div>
    <div className="row columns">
      { subcategory_id?
      <WrappedForm subcategory_id={subcategory_id} /> :
      <PricingCategory showDifferentiators={false} showTestimonial={false}
        showReviewsAgg={false} showCta={false} /> }

      {cta_html &&
      <div className="small-16 columns">
        <div className="pricing-cta">
          <p dangerouslySetInnerHTML={{ __html: cta_html }} />
        </div>
      </div>
      }
    </div>
  </section>
);


PricingModule.propTypes = {
  subcategory_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  cta_html: PropTypes.string,
  background: PropTypes.string,
};


export default PricingModule;



// WEBPACK FOOTER //
// ./landing_pages/components/pricing.jsx